import { Container, Row, Col } from "react-bootstrap";
import 'swiper/css';

const Kiwi = () => {

    return (
        <section className="py-4 border-top text-center overflow-hidden px-2" style={{ background: '#ffffff' }}>
            {/* <Container fluid> */}
            <div className="position-relative mb-4 ">
                <h2 className="textRes" style={{
                    color: "#000",
                    textTransform: "uppercase",
                    fontSize: "clamp(2rem, 4vw, 4rem)",
                    fontWeight: "500",
                }}>
                    KIWA PVEL <span style={{ color: '#a20000' }}>Top Performer 2026</span>
                </h2>
            </div>


            <Container fluid>
                <Row className="justify-content-center">
                    <Col lg={8} md={11} xs={12}> 
                        <img
                            src="/KiwiBanner2.webp"
                            alt="Kiwi"
                            className="img-fluid rounded shadow"
                        />
                    </Col>
                </Row>
            </Container>
            {/* </Container> */}
        </section>
    );
};

export default Kiwi;